module.exports = {"360730100":"梅江镇","360730101":"青塘镇","360730102":"长胜镇","360730103":"黄陂镇","360730104":"固村镇","360730105":"赖村镇","360730106":"石上镇","360730107":"东山坝镇","360730108":"洛口镇","360730109":"小布镇","360730110":"黄石镇","360730111":"田头镇","360730200":"竹笮乡","360730201":"对坊乡","360730202":"固厚乡","360730203":"田埠乡","360730204":"会同乡","360730205":"湛田乡","360730206":"安福乡","360730207":"东韶乡","360730208":"肖田乡","360730209":"钓峰乡","360730210":"大沽乡","360730211":"蔡江乡","360730400":"宁都县水东工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360730.json
// module id = 1197
// module chunks = 0